import SpecificationsDashboard from './SpecificationsDashboard';
export default SpecificationsDashboard;
